<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>素材管理 > <b>预设模板</b></BreadcrumbItem>
      </Breadcrumb>
	  <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
          <span class="search_span_width" style="margin-right: 5px;">
              <span class="search_span_width_part1">直播间ID:</span>
              <Input v-model="search.id" placeholder="请输入直播间ID" clearable :style="{'width':'150px'}"></Input>
          </span>
          <span class="search_span_width" style="margin-right: 5px;">
              <span class="search_span_width_part1">名称:</span>
              <Input v-model="search.name" placeholder="请输入直播间名称" clearable :style="{'width':'150px'}"></Input>
          </span>
          <span class="search_span_width" style="margin-right: 5px;">
              <span class="search_span_width_part1">渠道:</span>
              <Select v-model="search.channel" clearable style="width:200px">
                <Option v-for="item in channel_list" :value="item.id" :key="item.index">{{ item.name }}</Option>
              </Select>
          </span>
	        <span class="search_span_width">
	            <span class="search_span_width_part1">分类：</span>
	  				 <Select v-model="search.studio_type" style="width:260px">
	  				        <Option value="2" :key="2">客户端直播</Option>
	  						<Option value="1" :key="1">客户端视频</Option>
	  						<!-- <Option value="3" :key="3">小程序视频</Option> -->
	  				</Select>
	        </span>
	    <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getStudioList(1)">搜索</Button>
	  </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="studio_list"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="30" :show-elevator="true" @on-change="getStudioList"/>
        </Card>
      </Card>
    </Content>
	<Modal v-model="showtemplatemodal" :footer-hide=true title="设置为模板">
	     <Form ref="studio" :model="studio" :label-width="80" >
			<FormItem label="类型" prop="studio_type">
				<RadioGroup v-model="studio.studio_type">
					<Radio label="1">客户端视频</Radio>
					<Radio label="2">客户端直播</Radio>
					<!--<Radio label="3">小程序</Radio>-->
					<Radio label="4">AI智能成片</Radio>
					<!--<Radio label="8">AI一键成片(1号AI)</Radio>-->
					<Radio label="9">AI包装</Radio>
					<Radio label="11">商品视频</Radio>
					<Radio label="25">PC模板</Radio>
				</RadioGroup>
			</FormItem>
			<FormItem label="渠道" prop="channel" v-show="studio.studio_type==1 || studio.studio_type==8">
				 <Select v-model="studio.channel" style="width:260px">
				 	<Option v-for="item in channel_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
				 </Select>
			</FormItem>
	   
			  <FormItem>
			  <Button type="primary" @click="setTemplate()">提交</Button>
			   </FormItem>
	     </Form>
	 </Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			studio_type:'1',
			tag_id:0,
      name:'',
      channel: ''
		},
		channel_list:[],
		showmodal:false,
		showtemplatemodal:false,
		studio_list:[],
		recordTotal:0,
		page:1,
		studio:{
			studio_id:0,
			template:1,
			studio_type:0,
			channel:'all'
		},
		tableColumns:[
		{ title: '直播间ID', key: 'id', align: 'center' },
		{ title: '名称', key: 'name', align: 'center' },
		{ title: '标签', key: 'tag_name', align: 'center' },
		{ title: '排序', key: 'seq', align: 'center' },
		{ title: '操作', key: 'action', align: 'center',
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {      
						this.studio.studio_id = params.row.id;
						this.studio.studio_type = params.row.studio_type;
						this.showtemplatemodal = true;
					}
				  }
				}, '设为模板'),
			);
			return h("div",btns);
		  }
		}
		],
	}
  },
  mounted:function(){
    this.getStudioList();
	this.getSetting();
  },
  computed:{

  },
  methods:{
	getStudioList(page=this.page) {
		this.page = page;
		let p = {'page' : page};
		let params = Object.assign(this.search, p);
		this.http.get('/admin/studio/myStudioList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.studio_list = data.data.studio_list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	setTemplate(){
		this.http.post('/admin/studio/setTemplate',this.studio).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    this.showtemplatemodal = false;
			this.getStudioList();
		    return true;
		  }
		});
		
	},
	getSetting() {
		this.http.get('/admin/common/settingKey',{params:{'key':'app_channel'}}).then(response=>{
		  let data=response.data;
		  console.log(data);
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.channel_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
  }

}
</script>
